export default "__VITE_ASSET__a7c9b1d2__"